import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_ORGANIZATION_CATEGORY_TAGS,
  GET_ORGANIZATION_CATEGORY_TAGS,
  SG_FETCH_ORGANIZATION_CATEGORY_TAG,
  FETCH_ORGANIZATION_CATEGORY_TAG,
  SG_ADD_ORGANIZATION_CATEGORY_TAG,
  ADD_ORGANIZATION_CATEGORY_TAG,
  SG_UPDATE_ORGANIZATION_CATEGORY_TAG,
  UPDATE_ORGANIZATION_CATEGORY_TAG,
  SG_DELETE_ORGANIZATION_CATEGORY_TAG,
  DELETE_ORGANIZATION_CATEGORY_TAG,
  ORGANIZATION_CATEGORY_TAGS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getOrganizationCategoryTags(action) {
  try {
    yield put({ type: ORGANIZATION_CATEGORY_TAGS_PENDING });
    const response = yield call(api.GET_ORGANIZATION_CATEGORY_TAGS, action.payload);
    yield put({ type: GET_ORGANIZATION_CATEGORY_TAGS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchOrganizationCategoryTag(action) {
  try {
    yield put({ type: ORGANIZATION_CATEGORY_TAGS_PENDING });
    const response = yield call(api.FETCH_ORGANIZATION_CATEGORY_TAG, action.payload);
    yield put({ type: FETCH_ORGANIZATION_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addOrganizationCategoryTag(action) {
  try {
    yield put({ type: ORGANIZATION_CATEGORY_TAGS_PENDING });
    const response = yield call(api.ADD_ORGANIZATION_CATEGORY_TAG, action.payload);
    yield put({ type: ADD_ORGANIZATION_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateOrganizationCategoryTag(action) {
  try {
    yield put({ type: ORGANIZATION_CATEGORY_TAGS_PENDING });
    const response = yield call(api.UPDATE_ORGANIZATION_CATEGORY_TAG, action.payload);
    yield put({ type: UPDATE_ORGANIZATION_CATEGORY_TAG, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteOrganizationCategoryTag(action) {
  try {
    yield put({ type: ORGANIZATION_CATEGORY_TAGS_PENDING });
    yield call(api.DELETE_ORGANIZATION_CATEGORY_TAG, action.payload);
    yield put({ type: DELETE_ORGANIZATION_CATEGORY_TAG, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* organizationCategoryTagsSaga() {
  yield takeLatest(SG_GET_ORGANIZATION_CATEGORY_TAGS, getOrganizationCategoryTags);
  yield takeLatest(SG_FETCH_ORGANIZATION_CATEGORY_TAG, fetchOrganizationCategoryTag);
  yield takeLatest(SG_ADD_ORGANIZATION_CATEGORY_TAG, addOrganizationCategoryTag);
  yield takeLatest(SG_UPDATE_ORGANIZATION_CATEGORY_TAG, updateOrganizationCategoryTag);
  yield takeLatest(SG_DELETE_ORGANIZATION_CATEGORY_TAG, deleteOrganizationCategoryTag);
}